export default theme => ({
  image: {
    width: 'auto',
    maxWidth: '100%',
    maxHeight: '75vh',
    borderRadius: 5,
  },
});
